import { useState } from "react";
import UploadInput from "../../form-input/UploadInput";
import Logo from "../../logo/Logo";
import TextareaInput from "../../form-input/TextareaInput";
import DropDown from "../../form-input/DropDown";

const File = () => {
  const [front, setFront] = useState("");
  const [back, setBack] = useState("");
  const [otherside, setOtherside] = useState("");
  const [preview, setPreview] = useState("");

  const [description, setDescription] = useState("");
  const [defects, setDefects] = useState("");

  const [coverImage, setCoverImage] = useState(null);
  const [productLocation, setProductLocation] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productSize, setProductSize] = useState(null);

  const coverImageOptions = ["image one", "image two", "image three"];
  const sizeOptions = ["S", "M", "L", "XL"];

  return (
    <div className="lg:overflow-scroll w-full lg:scrollbar-thin  h-full">
      <div className="hidden pt-3 lg:block">
        <Logo />
      </div>
      <h3 className="font-bold text-xl xl:text-2xl mt-0 md:mt-10">
        Upload a good picture, it preserves your reputation
      </h3>
      <div className="flex gap-3 items-center mt-2">
        <p className="font-normal text-base text-logoRed">
          Read our community guidelines
        </p>
        <div className="flex justify-center items-center rounded-full bg-logoRed h-4 w-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="currentColor"
            className="bi bi-chevron-right text-white"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
      </div>
      <div className="w-full md:w-98 mt-10 flex  gap-3 flex-wrap">
        <UploadInput
          title="Front"
          value={front}
          onValueChange={setFront}
          setPreview={setPreview}
        />
        <UploadInput
          title="Back"
          value={back}
          onValueChange={setBack}
          setPreview={setPreview}
        />
        <UploadInput
          title="Other side"
          value={otherside}
          onValueChange={setOtherside}
          setPreview={setPreview}
        />
      </div>
      {preview ? (
        <>
          <p className="font-bold text-base mt-10">Preview</p>
          <div className="w-full md:w-98 h-72">
            <div className="w-full h-full">
              <img
                src={`${preview}`}
                alt="preview"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <TextareaInput
        placeholder="Product Description (Max: 100 words)"
        value={description}
        onValueChange={setDescription}
      />
      <TextareaInput
        placeholder="Any product defects?"
        value={defects}
        onValueChange={setDefects}
      />

      <DropDown
        value={coverImage}
        onValueChange={setCoverImage}
        options={coverImageOptions}
        placeholder="Select cover image"
      />

      <input
        type="text"
        className="h-[45px] rounded-md w-full md:w-95.7% mt-10 outline-none border border-solid border-darkGrey"
        placeholder="Enter product location"
        value={productLocation}
        onChange={(e) => setProductLocation(e.target.value)}
      />

      <input
        type="text"
        className="h-[45px] rounded-md w-full md:w-95.7% mt-10 outline-none border border-solid border-darkGrey"
        placeholder="Price"
        value={productPrice}
        onChange={(e) => setProductPrice(e.target.value)}
      />

      <DropDown
        value={productSize}
        onValueChange={setProductSize}
        options={sizeOptions}
        placeholder="Size"
      />
    </div>
  );
};

export default File;
